const COMPONENT_NAME = "feedback";
const FEEDBACK_BUTTON_ID = "opinionLabFooterLink";
const FEEDBACK_SCRIPT_SRC = "/opinionlab_us.min.js";
export {
  COMPONENT_NAME,
  FEEDBACK_BUTTON_ID,
  FEEDBACK_SCRIPT_SRC
};
